import { render } from "./CompanySuperAdmin.vue?vue&type=template&id=7ccec4c1&scoped=true"
import script from "./CompanySuperAdmin.vue?vue&type=script&lang=js"
export * from "./CompanySuperAdmin.vue?vue&type=script&lang=js"

import "./CompanySuperAdmin.vue?vue&type=style&index=0&id=7ccec4c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ccec4c1"]])

export default __exports__